import { userGroups } from "../helpers/UserGroups";

import { Route, Switch } from "react-router-dom";
import NotAuthorized from "./NotAuthorized";
import AddUserGroup from "../../pages/admin/AddItems/AddUserGroup";
import ManageUser from "../../pages/admin/user management/ManageUser";
import ChangePassword from "../../pages/admin/ChangePassword";
import Login from "../../pages/login/Login";
import NewPassword from "../../pages/login/NewPassword";
import UpdateEmail from "../../pages/login/UpdateEmail";
import UpdatePassword from "../../pages/login/UpdatePassword";
import Stock from "../../pages/Stock";
import Reports from "../../pages/Reports";
import AddStock from "../../pages/admin/AddItems/AddStock";
import Profile from "../../pages/settings/Profile";
import AuditTrails from "../../pages/admin/AuditTrails";
import Home from "../../pages/Home";
import SalesMain from "../../pages/sales_main";
import CustomerRegistration from "../../pages/CustomerRegistration";
import Items from "../../pages/Items";

const PageRoutes = () => {
  return (
    <div className="container-fluid" id="content">
      <Switch>
        {/* Home */}
        <Route path="/" exact>
          {userGroups().includes(1) ||
          userGroups().includes(2) ||
          userGroups().includes(3) ||
          userGroups().includes(4) ? (
            <Home />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/login" exact>
          <Login />
        </Route>
        <Route path="/new-password" exact>
          <NewPassword />
        </Route>
        <Route path="/update-email" exact>
          <UpdateEmail />
        </Route>
        <Route path="/update-password" exact>
          <UpdatePassword />
        </Route>
        <Route path="/add-user-group">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <AddUserGroup />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/manage-user">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <ManageUser />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/change-password">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <ChangePassword />
          ) : (
            <NotAuthorized />
          )}
        </Route>

        <Route path="/registration">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <CustomerRegistration />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/items">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <Items />
          ) : (
            <NotAuthorized />
          )}
        </Route>      
        <Route path="/stock">
          {userGroups().includes(1) ||
          userGroups().includes(2) ||
          userGroups().includes(3) ||
          userGroups().includes(4) ? (
            <Stock />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/add-stock">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <AddStock />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/audit-trails">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <AuditTrails />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/sales">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <SalesMain />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/reports">
          {userGroups().includes(1) || userGroups().includes(4) ? (
            <Reports />
          ) : (
            <NotAuthorized />
          )}
        </Route>
        <Route path="/profile">
          <Profile />        
        </Route>
      </Switch>
    </div>
  );
};

export default PageRoutes;
